const Redis = require("ioredis");

export default class RedisCaching {

    static client = null;

    static async getClient() {
        if (!RedisCaching.client) {
            RedisCaching.client = new Redis({
                host: process.env.REDIS_HOSTNAME.replace('redis://', ''),
            });
            return RedisCaching.client;
        }
        return RedisCaching.client; 
    }

    async set(key, ttl, value){
        const client = (await RedisCaching.getClient());
        await client.set(key, value);
        await client.expire(key, ttl);
    }
    
    async get(key) {
        return (await RedisCaching.getClient()).get(key);
    }
}